import React from 'react'
import {
  bool, func, object, string,
} from 'prop-types'
import axios from 'axios'

import Loader from 'Pods/Shared/Loader'
import Icon from 'Pods/Shared/Icon/Icon'

import UserInfoSection from './UserInfoSection'
import DesignersItems from './DesignersItems'

class DesignerRow extends React.Component {
  constructor() {
    super()

    this.state = {
      userItems: [],
      isDataFetched: false,
    }

    this.onItemsFetchSuccess = this.onItemsFetchSuccess.bind(this)
    this.renderData = this.renderData.bind(this)
    this.onItemsFetchFailure = this.onItemsFetchFailure.bind(this)
  }

  componentDidMount() {
    this.fetchUserItems()
  }

  componentDidUpdate(prevProps) {
    const { reload } = this.props
    if (prevProps.reload !== reload) {
      this.fetchUserItems()
    }
  }

  fetchUserItems() {
    const { userId, filters } = this.props
    const searchParams = { user_ids: [userId], per_page: 20 }

    if (filters.searchFilter === 'tags' && filters.keywords !== '') {
      searchParams.keywords = [filters.keywords]
      searchParams.sort_by = 'admin_rating'
      searchParams.fill_items = true
    }

    axios.get('/api/internal/items', { params: searchParams })
      .then(this.onItemsFetchSuccess).catch(this.onItemsFetchFailure)
  }

  onItemsFetchSuccess(response) {
    this.setState({
      userItems: response.data.data,
      isDataFetched: true,
    })
  }

  onItemsFetchFailure() {
    this.setState({
      isDataFetched: true,
    })

    // eslint-disable-next-line no-undef
    App.events.publish('app:notification:flash:error', 'Error')
  }

  renderData() {
    const { cart, user } = this.props
    const { userInfo } = user
    const { userItems } = this.state

    if (userItems.length > 0) {
      return <DesignersItems userItems={userItems} cart={cart} />
    }

    return (
      <div className="card designers-list__empty-row">
        <p className="heading-32 text-default"><Icon type={['far', 'image']} notSpaced /></p>
        <p className="heading-18">
          {userInfo.username} has not uploaded any models yet
        </p>
        <p className="text-default">Check the profile later!</p>
      </div>
    )
  }

  render() {
    const {
      filters,
      inviteDesignersPage,
      isInvited,
      jobId,
      messagingForbidden,
      onFiltersChange,
      user,
      userId,
    } = this.props
    const { userInfo, totals } = user
    const { isDataFetched } = this.state

    return (
      <div className="row designers-list__row">
        <div className="col-12 col-md-4 col-lg-3 col-xxl-2">
          <UserInfoSection
            userInfo={userInfo}
            totals={totals}
            handleLocationClick={onFiltersChange}
            filters={filters}
            messagingForbidden={messagingForbidden}
            inviteDesignersPage={inviteDesignersPage}
            isInvited={isInvited}
            userId={userId}
            jobId={jobId}
          />
        </div>
        <div className="col-12 col-md-8 col-lg-9 col-xxl-10">
          {isDataFetched ? this.renderData() : (
            <div className="user-models--loading">
              <div className="user-models__loading">
                <Loader isFullHeight />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

DesignerRow.propTypes = {
  user: object.isRequired,
  onFiltersChange: func.isRequired,
  filters: object.isRequired,
  cart: object.isRequired,
  messagingForbidden: bool,
  userId: string.isRequired,
  isInvited: bool.isRequired,
  jobId: string,
  inviteDesignersPage: bool.isRequired,
  reload: bool.isRequired,
}

DesignerRow.defaultProps = {
  messagingForbidden: undefined,
  jobId: undefined,
}

export default DesignerRow
